import type { PublicPlan } from './api';

export function planPricing(plan: PublicPlan, quantity = 1) {
  const current = Math.round(plan.priceCny * 100);
  const original = plan.originalPriceMinor ?? (plan.originalPriceCny == null ? null : Math.round(plan.originalPriceCny * 100));
  const discounted = original != null && original > current && current >= 0;
  return { current: current * quantity, original: discounted ? original * quantity : null,
    percent: discounted ? Number(((original - current) / original * 100).toFixed(1)) : null };
}
